import { View } from "@netent/playui";
import { IAdapterSetting } from "..";
import {
  IStoreAction,
  IUpdateGameSettingsAction,
  IUpdateViewAction
} from "./actions";
export * from "./actions";

export interface IStoreState {
  gameSettings: IAdapterSetting[];
  view: View;
}

const defaultState: IStoreState = {
  gameSettings: [],
  view: null
};

export function reducer(
  state = defaultState,
  action: IStoreAction
): IStoreState {
  switch (action.type) {
    case "UPDATE_GAME_SETTINGS":
      return {
        ...state,
        gameSettings: (action as IUpdateGameSettingsAction).value
      };
    case "UPDATE_VIEW":
      return { ...state, view: (action as IUpdateViewAction).value };
    default:
      return state;
  }
}
